import { ref } from 'vue';

export const searchVersionRef = ref(0);
